import React, { PropsWithChildren, FC } from "react";

import { FilterBar } from "Components/UI/TableFilters/TableFilters";

type TFilterWrapperProps = PropsWithChildren & {
  className?: string;
};

const FilterWrapper: FC<TFilterWrapperProps> = ({ children, className }) => (
  <FilterBar className={className}>{children}</FilterBar>
);

export default FilterWrapper;
